const sortFunctions = {
	// Alphabetical order by building name, address
	abc: (a,b) => {
		if (a.city < b.city) { return -1; }
		if (a.city > b.city) { return 1; }
		if (a.address < b.address ) { return -1 }
		if (a.address > b.address ) { return 1 }
		return 0;
	},
	abc_name: (a,b) => {
		if (a.name === '' && b.name !== '') { return 1; }
		if (a.name !== '' && b.name === '') { return -1; }

		if (a.name < b.name) { return -1; }
		if (a.name > b.name) { return 1; }

		return 0;
	},
	// Sort by available area
	size: (a,b) => a.total_area < b.total_area ? -1 : a.total_area > b.total_area ? 1 : 0,
};

const filterFunctions = {
	contact: ({ show, filter, building, hasFilters, onlyShowBuildingsWithFreeSpaces }) => {
		return building.contacts.findIndex(contact => contact === filter.value) > -1
	},
	// city: ({ show, filter, building }) => building.city.toLowerCase() === filter.value.toLowerCase(),
	spaceType: ({ show, filter, building, hasFilters, onlyShowBuildingsWithFreeSpaces }) => {
		if (onlyShowBuildingsWithFreeSpaces) {
			return show && building.spaces.some(space => space.type === filter.value && space.isFree);
		}

		return show && building.spaces.some(space => space.type === filter.value);
	},
	text: ({ show, filter, building }) => ( // TODO: Easier way to add matches
		JSON.stringify(building.city).toLowerCase().indexOf(filter.value.toLowerCase()) > -1 ||
		JSON.stringify(building.contacts).toLowerCase().indexOf(filter.value.toLowerCase()) > -1 ||
		JSON.stringify(building.address).toLowerCase().indexOf(filter.value.toLowerCase()) > -1 ||
		JSON.stringify(building.name).toLowerCase().indexOf(filter.value.toLowerCase()) > -1 ||
		building.i18n.fi.neighborhood.toLowerCase() === filter.value.toLowerCase() ||
		building.i18n.en.neighborhood.toLowerCase() === filter.value.toLowerCase()
	),
	region: ({ show, filter, building, hasFilters, onlyShowBuildingsWithFreeSpaces }) => {
		return (
			building.location.includes(filter.value) || (
				building.location.some(location => {
					return location.substr(0, filter.value.length) === filter.value
				})
			)
		)
	},
	area: ({ show, filter, building, onlyShowBuildingsWithFreeSpaces }) => {
		if (filter.key === 'min') {
			if (onlyShowBuildingsWithFreeSpaces) {
				return show && building.spaces.some(space => space.area >= filter.value && space.isFree);
			} else {
				return show && building.spaces.some(space => space.area >= filter.value);
			}
		}

		if (filter.key === 'max') {
			if (onlyShowBuildingsWithFreeSpaces) {
				return show && building.spaces.some(space => space.area <= filter.value && space.isFree);
			} else {
				return show && building.spaces.some(space => space.area <= filter.value);
			}
		}

		return show
	},
}

export {
	sortFunctions,
	filterFunctions,
}
